/**
 * assets/product-back-in-stock.js
 * Back-in-stock-formulier in de buy-box van snippets/product-buy-box.liquid
 *
 * Stuurt aanmeldingen naar webhooks.retailz.io. Bindt per formulier met een
 * eigen guard (__bisInit), zodat een tweede aanroep niets dupliceert.
 * Zie ARCHITECTURE.md sectie 11.
 */

(function () {
  var ENDPOINT = 'https://webhooks.retailz.io/api/back-in-stock';
  function initForm(root) {
    if (root.__bisInit) return; root.__bisInit = true;
    var email = root.querySelector('[data-bis-email]');
    var submit = root.querySelector('[data-bis-submit]');
    if (!email || !submit) return;
    var okText = root.getAttribute('data-bis-success') || 'We mailen je zodra hij er weer is.';
    var errText = root.getAttribute('data-bis-error') || 'Er ging iets mis. Probeer het zo nog eens.';
    var msg = document.createElement('p');
    msg.className = 'text-sm mt-2 hidden';
    root.appendChild(msg);
    function fail() { submit.disabled = false; msg.textContent = errText; msg.className = 'text-sm mt-2 text-koi'; }
    function go(e) {
      if (e) e.preventDefault();
      var val = (email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { fail(); return; }
      submit.disabled = true;
      msg.className = 'text-sm mt-2 hidden';
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: val,
          shopify_product_id: root.getAttribute('data-bis-pid') || '',
          shopify_variant_id: root.getAttribute('data-bis-vid') || '',
          sku: root.getAttribute('data-bis-sku') || '',
          handle: root.getAttribute('data-bis-handle') || '',
          title: root.getAttribute('data-bis-title') || '',
          url: root.getAttribute('data-bis-url') || ''
        })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          if (!d || !d.ok) return Promise.reject();
          email.style.display = 'none';
          submit.style.display = 'none';
          msg.textContent = okText;
          msg.className = 'text-sm mt-2 text-aqua-donker font-semibold';
        })
        .catch(fail);
    }
    submit.addEventListener('click', go);
    var form = submit.closest('form');
    if (form) form.addEventListener('submit', go);
    email.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') go(ev); });
  }
  function initAll() { var fs = document.querySelectorAll('[data-bis-form]'); for (var i = 0; i < fs.length; i++) initForm(fs[i]); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
})();
